import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, StateManager, useBCMSContext, useParams, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from 'components/shared/containers/FormContainer';
import { UICancelButton, UIPrimaryButton } from 'components/ui/UIButton';
import UIRadio from 'components/ui/UIRadio';
import Classes, { Transaction } from 'model';
import React from 'react';
import { SVGAsset } from 'res';
import "./styles.css";

/**
 * @function DisputeTransactionReasonView
 * @return {React.Component}
 * @exported true
 * @description The view that asks why the transaction is being disputed.
 */

export default function DisputeTransactionReasonView(props) {
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  const navigate = useRoute();

  const { goStep, nextStep, prevStep, state } = useWorkflow() ?? {};
  const paramsTransactionID = useParams().transactionID ?? "0";
  const data = { ...getDefaultData(paramsTransactionID), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    update: reason => () => {
      BCMSStateManagerCRUD.init(state)
        .update([ "data", "dispute", "whyAreYouDisputingThisTransaction" ], reason)
        .update([ "ui" ], ui)
        .submit(setState);
    },

    next: evt => {
      goStep(2, { data, ui });
    },

    cancel: () => {
      //navigate("/home/disputetransaction");
      goStep(0)
    }
  });

  return(
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = transactionID => {
  const transaction = Transaction.initByID(transactionID);
  const dispute = BCMSDefaultModel.transactionDispute();
  dispute.transaction = transaction;

  return {
    dispute
  }
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, next, cancel, update } = useStateManager();
  const dispute = data.dispute ?? {};

  const buttonItems = [
    { id: "0", label: "Dissatisfied with merchandise or service", dataPoint: "Selection_Dissatisfied", val: "dissatisfied with merchandise or service" },
    { id: "1", label: "Merchandise or service not received", dataPoint: "Selection_Merchandise_Not_Received", val: "merchandise or service not received", disabled: true },
    { id: "2", label: "Merchandise or service canceled", dataPoint: "Selection_Merchandise_Canceled", val: "merchandise or service canceled", disabled: true },
    { id: "3", label: "Charged incorrectly", dataPoint: "Selection_Charged_Incorrectly", val: "charged incorrectly", disabled: true },
  ];

  const radioButtons = buttonItems.reduce((acc, item) => {
    const disabled = item.disabled ? { disabled: "true" } : {};
      acc.push(
        <UIRadio key={ item.id } { ...disabled } value={ dispute.whyAreYouDisputingThisTransaction === item.val } 
            label={ item.label } dataPoint={ item.dataPoint } onChange={ update(item.val) } />
      );
      return acc;
  }, []);

  const nextButtonDataPoint = { dataPoint: "Next_Button" };
  
  return (
    <div className="dispute-transaction-reason-view">
      <FormContainer>
      <FormRow className="radio-group">
          <p className="form-label">Why are you disputing this transaction? *</p>
          { radioButtons }
        </FormRow>

        <FormRow className="flex-container flex-horizontal">
          <SVGAsset id="InformationIcon" className="info-icon left-inline-icon set-width" />
          <p className="sub-text">You will be asked a series of questions necessary to process your dispute. 
          This can take several minutes to complete. Being descriptive as possible will minimize the time it takes to 
          resolve the dispute. Alternatively, you can speak to an agent by calling.</p>
        </FormRow>
        <FormButtonContainer>
          <UIPrimaryButton text="Next" { ...nextButtonDataPoint } onClick={ next } />
          <UICancelButton text="Cancel" onClick={ cancel } />
        </FormButtonContainer>
      </FormContainer>
    </div>
  )
}

